import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 爆料网上",
    description: "你访问的页面不存在或已被移除，可返回首页或事件追踪总览继续浏览热点事件时间线。",
    path: location.pathname,
  });

  return (
    <section className="w-full px-5 md:px-10 pt-32 md:pt-40 pb-24 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-primary-200 bg-primary-50 text-xs text-primary-700">
          <i className="ri-error-warning-line" />
          404 · 页面未找到
        </span>
        <h1 className="mt-6 font-heading text-3xl md:text-5xl font-black text-foreground-950">
          这条线索断了
        </h1>
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
          你访问的页面不存在，或对应的事件已被合并到其它时间线。
        </p>
        <p className="mt-2 text-xs text-foreground-400 break-all">{location.pathname}</p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-1.5 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/events"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-1.5 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-list-check-2" />
            浏览事件追踪
          </Link>
        </div>
      </div>
    </section>
  );
}